import { ProjectDocTypeVals } from "./ProjectDocTypes";

// Дублирует комментарии из ProjectDocTypes.ts
export const projectDocTypeFilterOptions = [
  { label: `Техническое задание`, value: ProjectDocTypeVals.TS },
  { label: `Изменение в техническое задание`, value: ProjectDocTypeVals.TSC },
  { label: `Проектная документация`, value: ProjectDocTypeVals.PD },
  { label: `Изменение в ПД`, value: ProjectDocTypeVals.PDEdit },
  { label: `Рабочая документация`, value: ProjectDocTypeVals.WD },
  { label: `Изменение в РД`, value: ProjectDocTypeVals.WDEdit },
  { label: `Инженерные изыскания`, value: ProjectDocTypeVals.II },
  { label: `Изменение в ИИ`, value: ProjectDocTypeVals.IIEdit },
  { label: `Исходные данные`, value: ProjectDocTypeVals.OriginalData },
  { label: `Исходно-разрешительная документация`, value: ProjectDocTypeVals.IPA },
  { label: `Изменение в ИРД`, value: ProjectDocTypeVals.IPAEdit },
  { label: `Исполнительная документация`, value: ProjectDocTypeVals.Executive },
];
